import SearchViewPannel from './SearchViewPannel';

export default SearchViewPannel;
